import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconNook20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconNook20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.394 13.821a.25.25 0 0 1 .112.208v1.066l-6.753-3.636V3.738l.922.576a.25.25 0 0 1 .117.212v2.031c0 .636.345 1.221.9 1.53l1.828 1.016a.25.25 0 0 1 .129.218v1.733c0 .585.292 1.132.78 1.456zM9.253 11.46 2.5 15.095V14.03a.25.25 0 0 1 .111-.208l1.966-1.31a1.75 1.75 0 0 0 .78-1.457V9.321a.25.25 0 0 1 .128-.218l1.828-1.016c.556-.309.9-.894.9-1.53V4.526a.25.25 0 0 1 .118-.212l.922-.576zm-5.94 4.902 6.69-3.602 6.69 3.602-1.197.665a.25.25 0 0 1-.234.005l-1.645-.823a1.75 1.75 0 0 0-1.493-.034l-2.02.898a.25.25 0 0 1-.203 0l-2.02-.898a1.75 1.75 0 0 0-1.492.034l-1.646.823a.25.25 0 0 1-.233-.005zm15.294.652-2.383 1.324a1.75 1.75 0 0 1-1.632.036l-1.646-.823a.25.25 0 0 0-.213-.005l-2.02.898a1.75 1.75 0 0 1-1.42 0l-2.02-.898a.25.25 0 0 0-.214.005l-1.645.823a1.75 1.75 0 0 1-1.633-.036l-2.395-1.33L1 16.791v-2.763c0-.585.292-1.131.78-1.456l1.965-1.31a.25.25 0 0 0 .112-.209V9.321c0-.635.344-1.221.9-1.53l1.828-1.015a.25.25 0 0 0 .128-.219V4.526c0-.604.311-1.164.823-1.484l2.07-1.294.397-.248.397.248 2.07 1.294c.511.32.822.88.822 1.484v2.031c0 .091.05.175.129.219l1.828 1.015c.555.309.9.895.9 1.53v1.733a.25.25 0 0 0 .111.208l1.966 1.311c.487.325.78.871.78 1.456v2.763l-.372.207z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconNook20);
